module.exports = __webpack_public_path__ + "static/media/close_gray.0cb4b0b4.svg";